var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"big-map-box"},[_c('div',{staticClass:"map-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"map-content",attrs:{"id":"PointCloudmap"}}),_c('div',{staticClass:"map-darkcorner"})])}
var staticRenderFns = []

export { render, staticRenderFns }